module.exports = __webpack_public_path__ + "img/terImg6.8b5e9b98.png";